exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-edit-output-scheme-dialog .ant-form-item {\n  flex-flow: column;\n  margin-bottom: 16px;\n}\n.create-edit-output-scheme-dialog .ant-form-item .ant-form-item-label {\n  text-align: left;\n  padding: 0;\n}\n.create-edit-output-scheme-dialog .ant-form-item-explain {\n  margin-top: 8px;\n  font-size: 11px;\n  min-height: unset;\n}\n", ""]);

// exports
